import { render, staticRenderFns } from "./EditProducts.vue?vue&type=template&id=90edc44c&scoped=true&"
import script from "./EditProducts.vue?vue&type=script&lang=js&"
export * from "./EditProducts.vue?vue&type=script&lang=js&"
import style0 from "./EditProducts.vue?vue&type=style&index=0&id=90edc44c&prod&scoped=true&lang=css&"
import style1 from "./EditProducts.vue?vue&type=style&index=1&id=90edc44c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90edc44c",
  null
  
)

export default component.exports